import firebase from 'firebase/app';
import 'firebase/database';

// Config fournis par firebaser
const config = {
    apiKey: "AIzaSyBGfiMYgaIbOrBlNAOvb9SgBaHv5u6VR3g",
    authDomain: "m516-technologie-du-web-mobile.firebaseapp.com",
    databaseURL: "https://m516-technologie-du-web-mobile.firebaseio.com",
    projectId: "m516-technologie-du-web-mobile",
    storageBucket: "m516-technologie-du-web-mobile.appspot.com",
    messagingSenderId: "816045775898"
};

// Initialisation de firbase
firebase.initializeApp(config);

// Exportation des variable utiliser
export const database = firebase.database();
export const playersRef=database.ref('players');